import { createSlice } from "@reduxjs/toolkit";
import teamState from "../../../constants/team/teamState";

// Create a Redux slice for the 'Team' portion of the state
export const teamSlice = createSlice({
  name: "team", // The name of the slice
  initialState: teamState, // Initial state for Team
  reducers: {
    // Set team data action
    setTeamData: (state, action) => {
      state.data = action.payload;
    },
    // Set team ID action
    setTeamId: (state, action) => {
      state.data.teamId = action.payload;
    },
    // Set owner status action
    setIsOwner: (state, action) => {
      state.data.isOwner = action.payload;
    },
    // Set teams action
    setTeams: (state, action) => {
      state.data.teams = action.payload;
    },
    // Set team members action
    setTeamMembers: (state, action) => {
      state.data.teamMembers = action.payload;
    },
    // Set invitations action
    setInvitations: (state, action) => {
      state.data.invitations = action.payload;
    },
    // Set active section action
    setTeamActiveSection: (state, action) => {
      state.data.activeSection = action.payload;
    },
    // Set Accessible Section action
    setTeamAccessibleSection: (state, action) => {
      state.data.accessibleSection = action.payload;
    },
    // Set Accessible Section Loaded action
    setIsAccessibleSectionLoaded: (state, action) => {
      state.data.isAccessibleSectionLoaded = action.payload;
    },
  },
});

// Destructure the action creators for easy access
export const {
  setTeamData,
  setTeamId,
  setIsOwner,
  setTeams,
  setTeamMembers,
  setInvitations,
  setTeamActiveSection,
  setTeamAccessibleSection,
  setIsAccessibleSectionLoaded,
} = teamSlice.actions;

// Export the reducer
export default teamSlice.reducer;
